import { useLocation, useNavigate } from "@tanstack/react-router";
import { useCallback, useMemo } from "react";

import type { SearchType } from "@/react/components/search/types";

import {
  buildSpotlightSearch,
  clearSpotlightSearch,
  readSpotlightSearchParams,
} from "../utils/spotlightSearchUrl";

interface SyncParams {
  query?: string | null;
  tab?: SearchType | null;
}

export const useSpotlightSearchUrl = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = useMemo(
    () => readSpotlightSearchParams(location.searchStr),
    [location.searchStr],
  );

  const syncToUrl = useCallback(
    ({ query, tab }: SyncParams) => {
      // TODO: Replace with a more TSR standard approach to update the search params instead of building the search string manually
      const nextSearch = buildSpotlightSearch(location.searchStr, {
        query,
        tab,
      });
      void navigate({
        href: nextSearch
          ? `${location.pathname}?${nextSearch}`
          : location.pathname,
        replace: true,
      });
    },
    [location.pathname, location.searchStr, navigate],
  );

  const clearFromUrl = useCallback(() => {
    const nextSearch = clearSpotlightSearch(location.searchStr);
    void navigate({
      href: nextSearch
        ? `${location.pathname}?${nextSearch}`
        : location.pathname,
      replace: true,
    });
  }, [location.pathname, location.searchStr, navigate]);

  return { params, syncToUrl, clearFromUrl };
};
